export default import.meta.ROLLUP_FILE_URL_hd_BXCx25dCCiTFVAMV3Fg;